import axios from "axios";
import { sendMobile } from "./mobile";
import moment from "moment";

export const handleDownloadWeb = async (url, nameFile) => {
    try {
        const token = localStorage.getItem('auth');
        console.log(token);
        
        const response = await axios.get(url+ nameFile + '.pdf', {
          responseType: 'blob',  
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true
        });

        console.log(response);
        
    
        
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    
        
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = nameFile + '.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
    
        // 🧹 Limpia memoria
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('Error al descargar el archivo web:', error);
    }
}
export const handleDownloadMovil = async (url, nameFile) => {
    try {
        let send = {
          type: 'action',
          action: 'export_voucher',
          data: url + nameFile + '.pdf',
          nameFile: nameFile + moment().format('YYYY-MM-DD'),
          extension: 'pdf',
          messageSend: 'Voucher',
          aditional: 'datavoucher'
        };
        sendMobile(JSON.stringify(send));
      } catch (error) {
        console.error('Error al descargar el archivo movil:', error);
    }
}